import React from "react";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import Proof from "./components/Proof";
import TrustMarquee from "./components/TrustMarquee";
import Pillars from "./components/Pillars";
import WhyUs from "./components/WhyUs";
import CostAdvantage from "./components/CostAdvantage";
import Portfolio from "./components/Portfolio";
import Pipeline from "./components/Pipeline";
import VawWorldOS from "./components/VawWorldOS";
import OTTDistribution from "./components/OTTDistribution";
import Showreel from "./components/Showreel";
import Originals from "./components/Originals";
import Numbers from "./components/Numbers";
import Blog from "./components/Blog";
import Magazine from "./components/Magazine";
import FAQ from "./components/FAQ";
import People from "./components/People";
import ContactCTA from "./components/ContactCTA";
import Footer from "./components/Footer";
import { useLenis } from "./hooks/useLenis";

export default function VawWorld() {
  useLenis();
  return (
    <div
      className="bg-[var(--vw-bg)] text-[var(--vw-text)]"
      style={{ overflowX: "clip" }}
      data-testid="vw-page"
    >
      <Nav />
      <main>
        <Hero />
        <Proof />
        <TrustMarquee />
        <Pillars />
        <CostAdvantage />
        <VawWorldOS />
        <Portfolio />
        <Pipeline />
        <WhyUs />
        <OTTDistribution />
        <Showreel />
        <Originals />
        <Numbers />
        <Blog />
        <Magazine />
        <FAQ />
        <People />
        <ContactCTA />
      </main>
      <Footer />
    </div>
  );
}
